import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

import Admin from '../../../Api/Models/Admin';
import useGlobalState from '../../GlobalStateContext';
import { ROLES } from '../../services/AdminPolicyService';
import axios from '../../services/MyAxios';
import AttachPermission from '../attach/AttachPermission';
import AttachRole from '../attach/AttachRole';
import PermissionsList from '../permissions/PermissionsList';
import RolesList from '../roles/RolesList';

import AdminDetails from './AdminDetails';
import AdminMetrics from './AdminMetrics';

import AttachModalButton from 'crm/elements/AttachModalButton';
import useNumberParams from 'crm/hooks/useNumberParams';

type Props = {
    id?: number;
};

const AdminShow = ({ id }: Props) => {
    if (!id) {
        id = useNumberParams().id;
    }
    const [admin, setAdmin] = useState<Admin>({} as Admin);
    const url = '/crea/api/admin/';
    const metricsUrl = `/crea/api/metrics/${id}`;
    const notificationsEnabled = process.env.MIX_NOTIFICATIONS_ENABLED === 'true';
    const { loggedAdmin } = useGlobalState();
    const canModify = loggedAdmin.canModify(admin);
    const [errorResponse, setErrorResponse] = useState(false);
    const [refreshPermissions, setRefreshPermissions] = useState(false);
    const [refreshRoles, setRefreshRoles] = useState(false);

    const handleRefreshPermissions = () => {
        setRefreshPermissions(prev => !prev);
    };
    const handleRefreshRoles = () => {
        setRefreshRoles(prev => !prev);
    };

    useEffect(() => {
        axios
            .get(`${url + id}?transformStateAndCountryFields`)
            .then((response) => setAdmin(response.data))
            .catch(() => setErrorResponse(true));
    }, []);

    return loggedAdmin.canView(admin) ? (
        <>
            {notificationsEnabled && <AdminMetrics url={metricsUrl} />}
            <AdminDetails admin={admin} />
            {canModify && (
                <AttachModalButton
                    url={`/admin/${id}/attach/permission`}
                    title="Attach Permission"
                    roles={ROLES.SUPER_ADMINS}
                    AttachEl={AttachPermission}
                    setUpdateTrigger={handleRefreshPermissions}
                />
            )}
            <PermissionsList source="admin" relatedId={id} showDetach={canModify} refresh={refreshPermissions} />
            {canModify && (
                <AttachModalButton
                    url={`/admin/${id}/attach/role`}
                    title="Attach Role"
                    roles={ROLES.MAIN_ADMINS}
                    AttachEl={AttachRole}
                    setUpdateTrigger={handleRefreshRoles}
                />
            )}
            <RolesList source="admin" relatedId={id} showDetach={canModify} refresh={refreshRoles} />
        </>
    ) : errorResponse ? (
        <Alert variant="warning">Administrator with that ID couldn't be found.</Alert>
    ) : null;
};

export default AdminShow;
